import { getLocale } from "../runtime";

const sv_nosearchresults = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Inga sökresultat hittades`
};

const nosearchresults = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_nosearchresults(inputs)
	return "noSearchResults";
};

export { nosearchresults as "noSearchResults" };